var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-12"},[_c('CompanyTable2')],1)}
var staticRenderFns = []

export { render, staticRenderFns }